import React, { Component} from "react";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';

  
export default  class Sharelink extends React.Component {
	 constructor(props) {
    super(props);
	 const currentUrl = window.location.href; 
	   let newUrl="";
    	 if (currentUrl.includes("Estimateviewmore")) {
     newUrl = currentUrl.replace("Estimateviewmore", "Estimateviewmoreshare");
    //window.location.href = newUrl; // redirect to new URL
}
else if (currentUrl.includes("Salesinvoiceviewmore")) {
     newUrl = currentUrl.replace("Salesinvoiceviewmore", "Salesinvoiceviewmoreshare");
    //window.location.href = newUrl; // redirect to new URL
}else{
	newUrl=currentUrl
}
   
 this.state = {
	
 openshare:false,urllink:newUrl,erropen:false,
   
	}
	      
	}
	
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
	 handlSharebox = () => {
       
        this.setState({ openshare: !this.state.openshare }); 
    };
	handleCopyLink = () => {
       
        navigator.clipboard.writeText(this.state.urllink)
            .then(() => {
               
this.setState({open:false,erropen:true});				
            })
           
    };
	render() {
	
return (

		  <React.Fragment>
		  
		  
<Dialog
    open={this.state.openshare}
    onClose={this.handlSharebox}
    maxWidth="xs"
    fullWidth={true}
  >
    <DialogTitle id="form-dialog-title" className="dialoghead">
  
    </DialogTitle>
    <DialogContent>
		<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="success"
        >
       Copied!!!
        </Alert>
      </Collapse></p>
	
	<p><TextField
	fullWidth
	value={this.state.urllink}
    InputLabelProps={{shrink: true }}
    ref={this.usernameInput}
	inputProps={{ tabIndex: "10",maxLength:100  }} 
            />
	</p>
	
	
   <React.Fragment>
    <div className="actionbtns">
     <div className="cancelbtn">
            <Button variant="contained" className="frmthirdbtn" onClick={this.handlSharebox}>
              Close
            </Button>
          </div>
          <div className="savebtn">
            <Button variant="contained" className="frmSecondarybtn" onClick={this.handleCopyLink}>
              copy link
            </Button>
          </div>
          <div className="clear"></div>
        </div>
      </React.Fragment>
    </DialogContent>
  </Dialog>
		   </React.Fragment>
		   )
	}
}
	
	
	 





 



	
	





